import { Color4, Scene, SceneOptions } from 'babylonjs' // This is core lib

import { Context3D } from '../3d-context'

interface ISceneOptions extends SceneOptions {}

// https://doc.babylonjs.com/divingDeeper/scene
/**
 * Creates scene
 */
export function setupScene(
  options: ISceneOptions = {},
  context = Context3D.get()
) {
  if (!context.engine) return

  // Create a basic BJS Scene object
  const scene = new Scene(context.engine)
  scene.clearColor = new Color4(1, 1, 1)
  scene.autoClear = true
  Context3D.set({ scene })

  return scene
}

/**
 * Show/hide inspector menu
 */
export function toggleInspector(context = Context3D.get()) {
  // Show inspector. https://doc.babylonjs.com/toolsAndResources/tools/inspector

  if (context.scene?.debugLayer.isVisible()) {
    context.scene?.debugLayer.hide()
    return
  }

  context.scene?.debugLayer.show({
    overlay: true,
  })
}
